type Args = {
  id: string;
  email: string;
  name: string;
  phone: string | null | undefined;
  mainOffice: string | null | undefined;
  first_admin: boolean | null | undefined;
  signed_up_at: number | null | undefined;
  intercomHash: string;
};

const getUserDetails = ({
  id,
  email,
  name,
  phone,
  mainOffice,
  first_admin,
  signed_up_at,
  intercomHash,
}: Args) => {
  // Do not send dathuis details to intercom (as our e2e tests create loads of
  // e-mails). With identity verification enabled, the token is bound to the
  // real userId so we can no longer mask the id — skip Intercom entirely.
  if (email.endsWith('@dathuis.nl') || email.endsWith('@bndl.nl')) return null;

  // `intercomHash` is the BE field name, but the value is actually a JWT
  // signed with the Intercom Messenger secret. Send it as `intercom_user_jwt`,
  // not `user_hash` — those are two different Intercom verification mechanisms.
  return {
    email,
    user_id: id,
    intercom_user_jwt: intercomHash,
    name,
    phone: phone ? phone : '',
    main_office: mainOffice ? mainOffice : '',
    first_admin: first_admin,
    signed_up_at: signed_up_at,
  };
};

export default getUserDetails;
